import { Component } from 'react'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import * as styles from 'styles/atoms/YoutubePlayer.css'

type YoutubePlayerProps = {
  playerId: string
  videoId: string
  width: number
  height: number
  playerVars: object
  onEnd?: () => void
}

type YoutubePlayerState = {
  isReady: boolean
}

class YoutubePlayer extends Component<YoutubePlayerProps, YoutubePlayerState> {

  static defaultProps: Partial<YoutubePlayerProps> = {
    playerVars: {},
  }

  state = {
    isReady: false,
  }

  player: YT.Player

  render () {
    const { playerId, width, height } = this.props

    return (
      <div>
        { !this.state.isReady && (
          <div
            className={ styles.spinnerWrapper }
            style={{
              width: `${ width }px`,
              height: `${ height }px`,
            }}
          >
            <Spinner size='large' />
          </div>
        )}
        <div style={{ display: this.state.isReady ? '' : 'none' }}>
          <div id={ playerId } />
        </div>
      </div>
    )
  }

  componentDidMount () {
    this.player = new YT.Player(this.props.playerId, {
      width: this.props.width,
      height: this.props.height,
      videoId: this.props.videoId,
      playerVars: this.props.playerVars,
      events: {
        onReady: this.handlePlayerReady,
        onStateChange: this.handlePlayerStateChange,
      },
    })
  }

  componentDidUpdate (prevProps: YoutubePlayerProps) {
    if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
      this.player.setSize(this.props.width, this.props.height)
    }
  }

  private handlePlayerReady = () => {
    this.setState({ isReady: true })
  }

  private handlePlayerStateChange = (event: { data: number }) => {
    if (event.data === YT.PlayerState.ENDED) {
      this.props.onEnd && this.props.onEnd()
    }
  }
}

export default YoutubePlayer
